export { default } from './ReptesPersonals';
